import RenderButtonGroup from ".";

export default function RenderButtonGroupBoolean ({
    value,
    setValue,
}: {
    value: boolean,
    setValue: (value: boolean) => void;
}) {
    const data = [{
        label: 'Yes',
        value: true
    }, {
        label: 'No',
        value: false
    }];

    return (
        <RenderButtonGroup 
            data={data}
            value={value}
            setValue={setValue}
        />
    );
}